import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from "../BaseApi";
import {errorCodeTranslation} from "../../Apis/ErrorCode";

const providersSlice = createSlice({
    name: 'providers',
    initialState: {
        getProvidersByUserId: {},
        getProvidersIncoming: {},
        getProvidersRecord: {},
        providerslistOfEmployees: {},
        getProvidersEmployeeSortList: [],
        uploadProviderImage: {},
        getProviderEmployeeDetail: {},
        getSingleProvider: {},
        checkProviderImage: {},
        getProviderImage: {},
        downloadProviderImage: {},
        downloadCompanyFile: {},
        createToExternal: {},
        setToExternal: {},
        providerVehicleSortList: [],
        providerlistOfVehicles: {},
        createVehicleAndRelationSupplier: {},
        getProviderVehicleDetail: {},
        getSingleProviderVehicle: {},
        checkProviderVehicleImage: {},
        getProviderVehicleImage: {},
        downloadProviderVehicleImage: {},
        getProviderVehicleStatus: [],
        UpdateProviderVehicleData: {},
        downloadCompanyVehicleFile: {},
        createToExternalVehicle: {},
        setToExternalVehicle: {},
        getOrderDetails: {},
        getAllProviderEmployeeListDown: [],
        getAllProviderVehicleListDown: [],
        getSingleUserProvider: {},
        getUserDocuments: {},
        getUserExtraData: {},
        getUserCompanyRestrictionData: {},
        getAllSupplierDocumentsById: [],
        createSupplierDocValue: {},
        setSupplierDocValue: {},
        saveProviderVehicleImage: {},
        saveProviderImage: {},
        imageChangeCheck: '',
        getSupplierInfoById: {}
    },
    reducers: {
        ClearGetSupplierInfoById: (state, action) => {
            state.getSupplierInfoById = {};
            state.getSingleProviderVehicle = {};
        },
    },
    extraReducers: {
        // order section
        'providers/getProvidersByUserId/fulfilled': (state, action) => {
            state.getProvidersByUserId = ResponseApi(action.payload);
        },

        'providers/getProvidersIncoming/fulfilled': (state, action) => {
            state.getProvidersIncoming = ResponseApi(action.payload);
        },
        'providers/getProvidersRecord/fulfilled': (state, action) => {
            state.getProvidersRecord = ResponseApi(action.payload);
        },

        'providers/getOrderDetails/fulfilled': (state, action) => {
            state.getOrderDetails = ResponseApi(action.payload);
        },

        'providers/getAllProviderVehicleListDown/fulfilled': (state, action) => {
            state.getAllProviderVehicleListDown = ResponseApi(action.payload);
        },
        'providers/getAllProviderEmployeeListDown/fulfilled': (state, action) => {
            state.getAllProviderEmployeeListDown = ResponseApi(action.payload);
        },

        // employees section

        'providers/providerslistOfEmployees/fulfilled': (state, action) => {
            state.providerslistOfEmployees = ResponseApi(action.payload);
        },

        // get supplier by id
        'contractor/getSupplierInfoById/fulfilled': (state, action) => {
            state.getSupplierInfoById = ResponseApi(action.payload);
        },
        'providers/getProvidersEmployeeSortList/fulfilled': (state, action) => {
            state.getProvidersEmployeeSortList = ResponseApi(action.payload);
        },
        'providers/uploadProviderImage/fulfilled': (state, action) => {
            state.uploadProviderImage = ResponseApi(action.payload);
        },
        'providers/getProviderEmployeeDetail/fulfilled': (state, action) => {
            state.getProviderEmployeeDetail = ResponseApi(action.payload);
        },
        'providers/getSingleProvider/fulfilled': (state, action) => {
            state.getSingleProvider = ResponseApi(action.payload);
        },
        'providers/checkProviderImage/fulfilled': (state, action) => {
            state.checkProviderImage = ResponseApi(action.payload);
        },

        'providers/getProviderImage/fulfilled': (state, action) => {
            state.getProviderImage = ResponseApi(action.payload);
        },
        'providers/downloadProviderImage/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.downloadProviderImage = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'providers/downloadCompanyFile/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.downloadCompanyFile = data;
            }
        },

        // createToExternal

        'providers/createToExternal/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createToExternal = data;
            }
        },

        'providers/setToExternal/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.setToExternal = data;
            }
        },

        // vehicle section slice
        'providers/providerlistOfVehicles/fulfilled': (state, action) => {
            state.providerlistOfVehicles = ResponseApi(action.payload);
        },

        'providers/providerVehicleSortList/fulfilled': (state, action) => {
            state.providerVehicleSortList = ResponseApi(action.payload);
        },
        'providers/createVehicleAndRelationSupplier/fulfilled': (state, action) => {
            state.createVehicleAndRelationSupplier = ResponseApi(action.payload);
        },

        'providers/checkProviderVehicleImage/fulfilled': (state, action) => {
            state.checkProviderVehicleImage = ResponseApi(action.payload);
        },

        'providers/getProviderVehicleImage/fulfilled': (state, action) => {
            state.getProviderVehicleImage = ResponseApi(action.payload);
        },
        'providers/downloadProviderVehicleImage/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.downloadProviderVehicleImage = data;
            }
        },

        'providers/getSingleProviderVehicle/fulfilled': (state, action) => {
            state.getSingleProviderVehicle = ResponseApi(action.payload);
        },
        'providers/getProviderVehicleDetail/fulfilled': (state, action) => {
            state.getProviderVehicleDetail = ResponseApi(action.payload);
        },
        'providers/getProviderVehicleStatus/fulfilled': (state, action) => {
            state.getProviderVehicleStatus = ResponseApi(action.payload);
        },

        'providers/UpdateProviderVehicleData/fulfilled': (state, action) => {
            state.UpdateProviderVehicleData = ResponseApi(action.payload);
        },
        'providers/saveProviderVehicleImage/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.saveProviderVehicleImage = data;
            }
        },

        'providers/downloadCompanyVehicleFile/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.downloadCompanyVehicleFile = data;
            }
        },

        // createToExternalVehcile

        'providers/createToExternalVehicle/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createToExternalVehicle = data;
            }
        },

        'providers/setToExternalVehicle/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.setToExternalVehicle = data;
            }
        },

        'providers/saveProviderImage/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};

            if (status >= 200 && status < 300) {
                const change = 0;
                state.saveProviderImage = data;
                state.imageChangeCheck = change + 1;
            }
        },

        // getUserDocuments  for user document

        'providers/getUserDocuments/fulfilled': (state, action) => {
            state.getUserDocuments = ResponseApi(action.payload);
        },

        'providers/getUserExtraData/fulfilled': (state, action) => {
            state.getUserExtraData = ResponseApi(action.payload);
        },
        'providers/getUserCompanyRestrictionData/fulfilled': (state, action) => {
            state.getUserCompanyRestrictionData = ResponseApi(action.payload);
        },

        'providers/getSingleUserProvider/fulfilled': (state, action) => {
            state.getSingleUserProvider = ResponseApi(action.payload);
        },

        'providers/getAllSupplierDocumentsById/fulfilled': (state, action) => {
            state.getAllSupplierDocumentsById = ResponseApi(action.payload);
        },

        'providers/setSupplierDocValue/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.setSupplierDocValue = data;
            }
        },
        'providers/createSupplierDocValue/fulfilled': (state, action) => {
            state.createSupplierDocValue = ResponseApi(action.payload);
        },
    },
});

export const { ClearGetSupplierInfoById } = providersSlice.actions;

export default providersSlice.reducer;
